import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">3.0.5 Case 5</h1>
            <p className="me-4">Estimated time to complete: 3-5 minutes</p>
          </section>
          <ModuleQuestion
            correctAnswer="B"
            assessmentName="self_assessment_105"
            videoTranscript={
              <>
                <p>
                  <strong>AUDIO</strong>
                  <br />
                  VO: (FEMALE)
                  <br />
                  This is self-assessment case number 105. This is a negative
                  scan. The size and contrast have already been adjusted.
                  Starting at the bottom of the brain, we identify the
                  cerebellum, located here, and see the normal gray-white
                  contrast. We also notice that there is increased noise
                  throughout the scan. Moving upwards and into the temporal and
                  occipital region, white matter tracts can be seen on the
                  right-hand side, located here, and, to a lesser degree, along
                  this thin strip here. The photopenic region, seen here,
                  corresponds to a large ventricle. It is also important to note
                  that the patient is tilted to the left, and this may cause
                  difficulty with interpretation. In order to confirm that this
                  activity along the ventricle is within white matter, utilize
                  your PET-CT fused images. As you can see, this streak of
                  activity is within white matter, adjacent to an enlarged
                  ventricle. Once again returning to the PET and moving upward,
                  you can see white matter tracts progressing to the posterior
                  aspect of the brain on both sides. Normal gray-white contrast
                  is also seen. As we enter into the frontal lobes, identified
                  here and here, gray-white contrast is also seen. This level of
                  contrast is within the normal range. White matter tracts can
                  be seen coursing from the front of the brain to the back on
                  the left and on the right. Entering into the parietal lobes,
                  again white matter tracts are easily identifiable on both
                  sides, with normal gray-white contrast seen in the lateral
                  aspects of the parietal region as well as in the medial
                  parietal region. Remembering to review all slices of the
                  brain, again, there is no loss of gray-white contrast in the
                  brain. Therefore, this scan is negative. If you interpreted
                  this scan as positive, I invite you to look at the case, once
                  again, in the MIM Cloud Viewer and to reconfirm that, in fact,
                  there is gray-white contrast throughout the brain, even though
                  there is ventriculomegaly, atrophy, and image noise.
                </p>
              </>
            }
            previousLesson="/module-3/module-3-0-4"
            nextLesson="/module-3/module-3-0-6"
            iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1967409204&entry_id=1_fpit3vp7&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
            questionType="assessment"
            videoId="1_fpit3vp7"
          />
        </main>
      </div>
    </div>
  );
};

export default Module_1_0;
